var $2a9c939f662747b6$exports = {};
$2a9c939f662747b6$exports = {
    "colorSwatchPicker": `Campioni di colore`,
    "dropzoneLabel": `Zona di rilascio`,
    "selectPlaceholder": `Seleziona un elemento`,
    "tableResizer": `Ridimensionamento`
};


export {$2a9c939f662747b6$exports as default};
//# sourceMappingURL=it-IT.mjs.map
